import Header from "@/components/Header";
import Hero from "@/components/Hero";
import ServicesPillars from "@/components/ServicesPillars";
import HowItWorks from "@/components/HowItWorks";
import EngagementModel from "@/components/EngagementModel";
import PrivateAccessBanner from "@/components/PrivateAccessBanner";
import ComplianceNotice from "@/components/ComplianceNotice";
import Footer from "@/components/Footer";

export default function Landing() {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Header />
      <main className="flex-1">
        <Hero />
        <ServicesPillars />
        <HowItWorks />
        <EngagementModel />
        <PrivateAccessBanner />
        <ComplianceNotice />
      </main>
      <Footer />
    </div>
  );
}
